import React, { useEffect, useState } from 'react'
import Webcam from 'react-webcam';
import { mobileModel } from "react-device-detect"
import { Typography, Box, Select, MenuItem, useTheme } from '@mui/material';

import { B64toBlob } from '../../utils'
import { useTranslation } from 'react-i18next';

export const CustomNativeCamera = props => {
  const theme = useTheme()
  const webcamRef = React.useRef(undefined);
  const [deviceId, setDeviceId] = React.useState({});
  const [devices, setDevices] = React.useState([]);
  const [controlCameraCustom, setControlCameraCustom] = useState(null)
  const [deviceIdDefault, setDeviceIdDefault] = React.useState(null);
  const selectDeviceCurrent = React.createRef()
  const isMobile = (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i))
  const { t } = useTranslation();

  if (navigator.mediaDevices === undefined) {
    navigator.mediaDevices = {};
    // console.log("*******undefined navigator.mediaDevices:******** ", navigator.mediaDevices)
  }

  const capture = React.useCallback(() => {
    let base64 = isMobile ? webcamRef.current?.getScreenshot({ width: 960, height: 1280 }) //se agrego la condicional ?
      : webcamRef.current.getScreenshot();
    console.log("imageSrc base64: ", base64)
    if (base64 != null && base64 != undefined) {
      base64 = base64.split(',')
      const blob = B64toBlob(base64[1], 'image/jpeg');
    console.log("imageSrc blob: ", base64)
      props.onCapture(blob)
    }
  }, [webcamRef]);

  useEffect(() => {
    try {
      // console.log("************devicedata deviceDetect************: ", deviceDetect()) // gives object shown in image below
      // console.log("************devicedata browserName*************: ", mobileModel) // gives "iphone"
      setDeviceId({})
      getDevices().then(gotDevices);
    } catch (ex) {
      console.log("Constructor Error: ", ex)
    }
  }, []);


  useEffect(() => {
    if (props.CaptureInit == true) {
      capture()
    }
  }, [props.CaptureInit])

  useEffect(() => {
    if (devices?.length > 0) {
      try {
        // console.log("devices?.length > 0 && mobileModel***: ", devices?.length, mobileModel)
        if (props.FacingMode == "environment" && devices.length > 1 && mobileModel.trimEnd() === 'moto g(8) plus') {
          let diviceFindSelect = devices?.find((item) => item.label == "camera2 0, facing back" ||
            item.label == "camera2 0, mirando hacia atrás")
          console.log("diviceFindSelect*********: ", diviceFindSelect)
          if (diviceFindSelect != undefined && diviceFindSelect != null && diviceFindSelect?.label != "") {
            console.log("idCurrent:, mobileModel: ", diviceFindSelect.deviceId, mobileModel)
            setDeviceId(diviceFindSelect.deviceId)
            setDeviceIdDefault(`I S Id: ${diviceFindSelect.deviceId}`)
            setControlCameraCustom(null)
          } else {
            console.log("*****************mobileModel*****devices***********: ", mobileModel, devices[devices.length - 1].deviceId)
            setDeviceId(devices[devices.length - 1].deviceId)
            setDeviceIdDefault(`E S Id: ${devices[devices.length - 1].deviceId}`)
            setControlCameraCustom(null)
          }
        }
        else if (props.FacingMode == "environment" && devices?.length > 1 && mobileModel == "moto e20") {
          let diviceFindSelect = devices?.find((item) => item.label == "camera2 0, facing back" ||
            item.label == "camera2 0, mirando hacia atrás")
          console.log("diviceFindSelect*********: ", diviceFindSelect)
          if (diviceFindSelect != undefined && diviceFindSelect != null && diviceFindSelect?.label != "") {
            console.log("idCurrent:, mobileModel: ", diviceFindSelect.deviceId, mobileModel)
            setDeviceId(diviceFindSelect.deviceId)
            setDeviceIdDefault(`IS_Id: ${diviceFindSelect.deviceId}`)
            setControlCameraCustom(null)
          } else {
            console.log("*****************mobileModel*****devices***********: ", mobileModel, devices[devices.length - 1].deviceId)
            setDeviceId(devices[devices.length - 1].deviceId)
            setDeviceIdDefault(`ES_Id: ${devices[devices.length - 1].deviceId}`)
            setControlCameraCustom(null)
          }
        }
        else if (props.FacingMode == "environment" && devices?.length > 1 && mobileModel == "YAL-L21") {
          let diviceFindSelect = devices?.find((item) => item.label == "camera2 0, facing back" ||
            item.label == "camera2 0, mirando hacia atrás")
          console.log("diviceFindSelect*********: ", diviceFindSelect)
          if (diviceFindSelect != undefined && diviceFindSelect != null && diviceFindSelect?.label != "") {
            console.log("idCurrent:, mobileModel: ", diviceFindSelect.deviceId, mobileModel)
            setDeviceId(diviceFindSelect.deviceId)
            setDeviceIdDefault(`IS_Id: ${diviceFindSelect.deviceId}`)
            setControlCameraCustom(null)
          } else {
            console.log("*****************mobileModel*****devices***********: ", mobileModel, devices[devices.length - 1].deviceId)
            setDeviceId(devices[devices.length - 1].deviceId)
            setDeviceIdDefault(`ES_Id: ${devices[devices.length - 1].deviceId}`)
            setControlCameraCustom(null)
          }
        }
        else if (props.FacingMode == "environment" && devices?.length > 1 && mobileModel == "SM-N975U") {
          let diviceFindSelect = devices?.find((item) => item.label == "camera2 0, facing back" ||
            item.label == "camera2 0, mirando hacia atrás")
          console.log("diviceFindSelect*********: ", diviceFindSelect)
          if (diviceFindSelect != undefined && diviceFindSelect != null && diviceFindSelect?.label != "") {
            console.log("idCurrent:, mobileModel: ", diviceFindSelect.deviceId, mobileModel)
            setDeviceId(diviceFindSelect.deviceId)
            setDeviceIdDefault(`IS_Id:${diviceFindSelect.deviceId}:****`)
            setControlCameraCustom(null)
          } else {
            console.log("*****************mobileModel*****devices***********: ", mobileModel, devices[devices.length - 1].deviceId)
            setDeviceId(devices[devices.length - 1].deviceId)
            setDeviceIdDefault(`ES_Id:${devices[devices.length - 1].deviceId}:****`)
            setControlCameraCustom(null)
          }
        }
        else if (props.FacingMode == "environment" && devices?.length > 1 && mobileModel == "SM-A336M") {
          let diviceFindSelect = devices?.find((item) => item.label == "camera2 0, facing back" ||
            item.label == "camera2 0, mirando hacia atrás")
          console.log("diviceFindSelect*********: ", diviceFindSelect)
          if (diviceFindSelect != undefined && diviceFindSelect != null && diviceFindSelect?.label != "") {
            console.log("idCurrent:, mobileModel: ", diviceFindSelect.deviceId, mobileModel)
            setDeviceId(diviceFindSelect.deviceId)
            setDeviceIdDefault(`IS_Id:${diviceFindSelect.deviceId}:****`)
            setControlCameraCustom(null)
          } else {
            console.log("*****************mobileModel*****devices***********: ", mobileModel, devices[devices.length - 1].deviceId)
            setDeviceId(devices[devices.length - 1].deviceId)
            setDeviceIdDefault(`ES_Id:${devices[devices.length - 1].deviceId}:****`)
            setControlCameraCustom(null)
          }
        }
        else if (props.FacingMode == "environment" && devices?.length > 1 && mobileModel == "SM-G991B") {
          let diviceFindSelect = devices?.find((item) => item.label == "camera2 0, facing back" ||
            item.label == "camera2 0, mirando hacia atrás")
          console.log("diviceFindSelect*********: ", diviceFindSelect)
          if (diviceFindSelect != undefined && diviceFindSelect != null && diviceFindSelect?.label != "") {
            console.log("idCurrent:, mobileModel: ", diviceFindSelect.deviceId, mobileModel)
            setDeviceId(diviceFindSelect.deviceId)
            setDeviceIdDefault(`IS_Id:${diviceFindSelect.deviceId}:****`)
            setControlCameraCustom(null)
          } else {
            console.log("*****************mobileModel*****devices***********: ", mobileModel, devices[devices.length - 1].deviceId)
            setDeviceId(devices[devices.length - 1].deviceId)
            setDeviceIdDefault(`ES_Id:${devices[devices.length - 1].deviceId}:****`)
            setControlCameraCustom(null)
          }
        }
        else if (props.FacingMode == "environment" && devices?.length > 1 && mobileModel == "K") {
          let diviceFindSelect = devices?.find((item) => item.label == "camera2 0, facing back" ||
            item.label == "camera2 0, mirando hacia atrás")
          console.log("diviceFindSelect*********: ", diviceFindSelect)
          if (diviceFindSelect != undefined && diviceFindSelect != null && diviceFindSelect?.label != "") {
            console.log("idCurrent:, mobileModel: ", diviceFindSelect.deviceId, mobileModel)
            setDeviceId(diviceFindSelect.deviceId)
            setDeviceIdDefault(`IS_Id:${diviceFindSelect.deviceId}:****`)
            setControlCameraCustom(null)
          } else {
            console.log("*****************mobileModel*****devices***********: ", mobileModel, devices[devices.length - 1].deviceId)
            setDeviceId(devices[devices.length - 1].deviceId)
            setDeviceIdDefault(`ES_Id:${devices[devices.length - 1].deviceId}:****`)
            setControlCameraCustom(null)
          }
        }
        // else if (props.FacingMode == "environment" && devices?.length > 1 && mobileModel == "SM-G950F") {
        //   let diviceFindSelect = devices?.find((item) => item.label == "camera2 0, facing back" ||
        //     item.label == "camera2 0, mirando hacia atrás")
        //   console.log("diviceFindSelect*********: ", diviceFindSelect)
        //   if (diviceFindSelect != undefined && diviceFindSelect != null && diviceFindSelect?.label != "") {
        //     console.log("idCurrent:, mobileModel: ", diviceFindSelect.deviceId, mobileModel)
        //     setDeviceId(diviceFindSelect.deviceId)
        //     setDeviceIdDefault(`IS_Id:${diviceFindSelect.deviceId}:****`)
        //     setControlCameraCustom(null)
        //   } else {
        //     console.log("*****************mobileModel*****devices***********: ", mobileModel, devices[devices.length - 1].deviceId)
        //     setDeviceId(devices[devices.length - 1].deviceId)
        //     setDeviceIdDefault(`ES_Id:${devices[devices.length - 1].deviceId}:****`)
        //     setControlCameraCustom(null)
        //   }
        // }
        else if (devices?.length > 2) {
          setDeviceId(null)
        } else {
          setDeviceId(null)
        }
      } catch (ex) {
        setDeviceId(null)
      }
    }
  }, [devices, mobileModel])

  useEffect(() => {
    console.log("******deviceId selected********: ", deviceId, " - controlCameraCustom: ", controlCameraCustom)
    if (deviceId != undefined && deviceId != null && deviceId?.length > 0) {
      console.log(" deviceId entro el ID selecccionado: ", deviceId)
      setControlCameraCustom(<Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        screenshotQuality={1}
        // imageSmoothing={true}
        style={props.isDisplay === false ? { display: 'none' } : { display: 'block' }}
        videoConstraints={{ deviceId: deviceId, echoCancellation: true, noiseSuppression: true }}
        mirrored={
          props.Mirrored === undefined || props.Mirrored == ""
            || props.Mirrored === null ? isMobile ? true : false
            : props.Mirrored
        }
      />)
    }
  }, [deviceId])

  let getDevices = () => {
    return navigator.mediaDevices.enumerateDevices();
  }

  let gotDevices = (deviceInfos) => {
    window.deviceInfos = deviceInfos;
    if (isMobile) {
      console.log("camerasBack****ALL FILTER**: ")
      setDevices(deviceInfos.filter(({ kind }) => kind == "videoinput"))
    } else {
      console.log("camerasBack****ALL SIN SIN FILTER**: ", deviceInfos)
      setDevices(deviceInfos)
    }
  }

  return (<>
    {props.FacingMode == "environment" && devices.length > 1 ?
      <Box sx={{
        // display: 'flex',
        display: 'none',
        width: '100%',
        justifyContent: "center",
        flexDirection: 'column',
        alignItems: "flex-start",
        position: 'fixed',
        top: 0,
        backgroundColor: "#FFF",
        zIndex: 200,
        minHeight: '7vh',
        // opacity: '0.5',
      }}>
        <Typography variant="subtitle2" color="primary" >
          {t("camera_low_resolution_text")}
        </Typography>
        <Select ref={selectDeviceCurrent}
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={deviceId}
          style={{ color: theme.palette.primary.main }}
          onChange={(e) => {
            setDeviceId(null)
            console.log("********handleChangeCamera***********e device Id***: ", e.target.value)
            setDeviceId(e.target.value)
          }}
        >
          {devices?.map((item, index) => {
            // return <MenuItem style={{ color: theme.palette.primary.main }} value={item.deviceId}>{mobileModel}-{item.label}-{item.deviceId}</MenuItem>
            // return <MenuItem style={{ color: theme.palette.primary.main }} value={item.deviceId}>Cámara {index + 1}</MenuItem>
            return <MenuItem style={{ color: theme.palette.primary.main }} value={item.deviceId}>{mobileModel}-{item.label}-Cámara {index + 1}</MenuItem>
          })
          }
        </Select>
        <Box sx={{
          display: 'flex',
          width: '100%',
          justifyContent: "center",
          flexDirection: 'column',
        }}>
          {deviceIdDefault != null ? <Box sx={{ overflow: 'auto' }} >
            Id D:  {deviceIdDefault}
          </Box> : null
          }
          {deviceId != undefined && deviceId != null && deviceId?.length > 0 ?
            <Box sx={{ overflow: 'auto' }} >
              Id C:  {deviceId}
            </Box> : null
          }
        </Box>
      </Box>
      : null}
    {
      props.width ? <>
        {/* {console.log("props.width: ", props.width)} */}
        {deviceId != undefined && deviceId != null && isMobile ? <>
          {console.log("controlCameraCustom render: : ", controlCameraCustom)}
          {controlCameraCustom}
        </> :
          <Webcam
            audio={false}
            onUserMedia={(e) => { console.log('Todo bien',e) }}
            onUserMediaError={(e) => { console.log('Dio error:', e) }}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            screenshotQuality={1}
            // imageSmoothing={true}
            style={props.isDisplay === false ? { display: 'none' } : { display: 'block' }}
            videoConstraints={{
              facingMode: props.FacingMode === undefined || props.FacingMode === null
                || props.FacingMode == "" ? "user" : props.FacingMode,
              width: parseInt(props.width),
              echoCancellation: true,
              noiseSuppression: true,
            }}
            mirrored={false/* props.Mirrored === undefined || props.Mirrored == ""
              || props.Mirrored === null ? isMobile ? true : false
              : props.Mirrored */}
          />
        }
      </> :
        (<Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          screenshotQuality={1}
          // imageSmoothing={true}
          style={props.isDisplay === false ? { display: 'none' } : { display: 'block' }}
          videoConstraints={{
            facingMode: props.FacingMode === undefined || props.FacingMode === null
              || props.FacingMode == "" ? "user" : props.FacingMode,
            echoCancellation: true,
            noiseSuppression: true,
          }}
          mirrored={false/* props.Mirrored === undefined || props.Mirrored == ""
            || props.Mirrored === null ? isMobile ? true : false
            : props.Mirrored */}
        />)
    }
  </>);
}